module.exports = __webpack_public_path__ + "img/kjhz-banner.982d07c3.jpg";